export const StaffUserQueryKeys = {
  all: () => ["staff-users"],
};
